<template>
  <div class="container-member-group container-search-chat">
    <div class="member-group-search flex-space-between container-input-search">
      <svg width="20px" height="20px"
           xmlns="http://www.w3.org/2000/svg" class="app-icon" role="img" viewBox="0 0 24 24">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M18.47 18.47a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06ZM11 18.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm9-7.5a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              fill="#26282C"></path>
      </svg>
      <input name="search" @keyup.stop.prevent="onKeyupSearch($event)" type="text" placeholder="Tìm kiếm thành viên" autocomplete="off" class="input-search" v-model="searchMember">
    </div>
    <hr>
    <div class="add-member" v-if="canAddMember">
      <div class="addmore cursor-pointer centerx">
        <button class="text-400-semibold add-member-button flex-space-between cursor-pointer w_100" type="button"
          @click="$modal.show('add-user-modal', {type: TYPE_ADD_GROUP_MEMBER.UPDATE_GROUP, group_id : group_id})" >
          <div class="add-member-button__icon">
            <md-icon class="primary_y500">add</md-icon>
          </div>
          Thêm thành viên
          <div class="centerx">

            <!--            <vs-button @click="popupActive=true" color="primary" type="border">Open Default popup</vs-button>-->
            <!--            <vs-popup class="holamundo"  title="Thêm thành viên" :active.sync="popupActive">-->
            <!--              <p>-->
            <!--               thành viên-->
            <!--              </p>-->
            <!--            </vs-popup>-->

          </div>
          <div class="app-button--overlay"></div>
        </button>
      </div>
    </div>
    <!-- tab-list-member-with-admin -->
    <div class="cs-tab-menu mb-15px">
      <div class="text-400-medium cursor-pointer" :class="{ active: tabActive == 1 }" @click="chosenTab(1)">Thành viên</div>
      <div class="text-400-medium cursor-pointer" :class="{ active: tabActive == 2 }" @click="chosenTab(2)">Quản trị viên</div>
      <div v-if="isAdmin" class="text-400-medium cursor-pointer" :class="{ active: tabActive == 3 }" @click="chosenTab(3)">Phê duyệt</div>
    </div>
    <!-- tab-list-member-with-admin -->

    <div class="list-members">
        <div class="contents">
          <template>
            <md-content class="md-scrollbar scroll-listmember">
              <vue-element-loading :active="isLoading" spinner="bar-fade-scale"/>
              <vue-loadmore
                  :on-loadmore="onLoad"
                  :finished="finished"
                  :loading-text="'Đang tải'"
                  :finished-text="tabActive === 2 && showSelfAppointAdmin ? '' : 'Hết'">
              <div
                v-if="showSelfAppointAdmin"
                class="self-appoint-admin"
              >
                <p class="self-appoint-admin__text text-300-default">
                  Nhóm chưa có quản trị viên. Thành viên có thể tự bổ nhiệm để quản lý nhóm.
                </p>
                <button
                  type="button"
                  class="btn-active text-400-semibold self-appoint-admin__btn"
                  :disabled="selfAppointing"
                  @click="selfAppointAdmin"
                >
                  {{ selfAppointing ? 'Đang bổ nhiệm...' : 'Tự bổ nhiệm QTV' }}
                </button>
              </div>
              <div v-for="member in resultSearch" :key="member.id">
                <div class="member-action-list">
                  <md-list-item class="cursor-pointer chooseMember user-detail">
                      <md-avatar>
                        <image-template
                          class="avatar"
                          :size="'small'"
                          :image="member.avatar_url"
                          :thumbnail="tabActive !== 3 ? member.avatar : member.thumbnail"
                          :name="member.fullname || member.name"
                        />
                      </md-avatar>
                      <div class="md-list-item-text">
                        <div class="text-400-medium mb-10px fullname">{{ member.fullname }}</div>
                        <div class="detail-info">
                          <span class="material-icons">schema</span>
                          <span class="text-info-name">
                              <span class="" v-if="member.parent_departement">{{ member.parent_departement.name }} > </span>
                              <span class="text-300-default" v-if="member.department">{{ member.department.name }}</span>
                              <span class="text-300-default" v-else>CÔNG TY</span>
                          </span>
                        </div>
                        <div class="detail-info" v-if="member.position">
                          <span class="material-icons">account_box</span>
                          <span class="text-info-name">{{ member.position.name }}</span>
                        </div>
                        <div class="detail-info">
                          <span class="material-icons">email</span>
                          <span class="text-info-name">{{ member.email }}</span>
                        </div>
                        <div class="detail-button-wrapper d-flex-space-between mt-10px" v-if="tabActive === 3">
                          <button
                            class="btn-active text-300-semibold"
                            :disabled="isBrowseRequestProcessing(member.id, true)"
                            @click="browseRequestJoinGroup(member.id, true)"
                          >
                            Đồng ý
                          </button>
                          <button
                            class="btn-stroke text-300-medium"
                            :disabled="isBrowseRequestProcessing(member.id, false)"
                            @click="browseRequestJoinGroup(member.id, false)"
                          >
                            Từ chối
                          </button>
                        </div>
                      </div>
                      <div class="listActions">
                        <div class="check-icon" v-on:click="dropDownAction(member.id)">
                          <span class="material-icons">more_horiz</span>
                        </div>
                      </div>
                    </md-list-item>
                  <div  v-click-outside="hideDropDown" v-if="dropDownId === member.id" class="contact-action-member" >
                    <div class="action" @click="goToProfile(member.id)">
                      <div class="icons"></div>
                      <div class="name">Xem trang cá nhân</div>
                    </div>
                    <div class="action" @click="setMemberAdmin(member)" v-if="canToggleAdminRole(member)">
                      <div class="icons set-member"></div>
                      <div class="name">{{ textSetRole(member.id) }}</div>
                    </div>
                    <div class="action remove-member" v-if="isAdmin && member.id !== user.id && tabActive != 3 && !isOfficialTeamGroupChat" @click="removeMember(member)">
                      <div class="icons delete-user"></div>
                      <div class="name">Xóa khỏi nhóm</div>
                    </div>
                    <!-- <div class="action">
                      <div class="icons"></div>
                      <div class="name">Xóa và chặn khỏi nhóm</div>
                    </div> -->
                  </div>
                </div>
              </div>
              </vue-loadmore>
            </md-content>
          </template>
        </div>
    </div>
    <div class="modal-add-member">
<!--      <add-member-group-chat-modal :info_group="infoGroup" ></add-member-group-chat-modal>-->
    </div>
  </div>

</template>

<script>
  import {TYPE_ADD_GROUP_MEMBER} from "../../../../../const/const";
  import ChatService from "../../../../../store/services/ChatService";
  import ImageTemplate from "../../../../../components/ImageTemplate";
  import { isOfficialTeamGroup } from "../../../../../helper/officialTeamGroup";
  import { canAddChatMember } from "../../../../../helper/chatGroupStore";

  export default {
  name: "MemberGroup",
  components: { ImageTemplate },
  props : {
    membersGroup : Array,
    infoGroup : Object,
    activeTab: {
        type: Number,
        default: 1,
      }
  },
  created() {
    // this.getMembersGroup();
  },
  mounted() {
    this.chosenTab(this.activeTab);
    this.getMembersGroup();
  },
  watch: {
    activeTab(newVal) {
      if (newVal != null && Number(newVal) !== Number(this.tabActive)) {
        this.chosenTab(newVal);
      }
    },
    '$store.state.chat.modifyMessageSocket'(newV) {
      const payload = newV.modifyData || newV;
      const evType = payload.type || newV.type;
      const data = payload.data || newV.data;

      if (evType === "set_role_admin") {
        const selected = this.$store.state.chat.chatGroupSelected || {};
        const patch = { ...selected };
        if (data?.user_id === this.user.id) {
          patch.is_admin = data.is_admin ? 1 : 0;
        }
        if (data?.group_id == null || String(data.group_id) === String(this.group_id)) {
          const current = Number(selected.active_admin_count);
          if (Number.isFinite(current)) {
            patch.active_admin_count = Math.max(0, current + (data.is_admin ? 1 : -1));
          }
        }
        this.$store.commit('chat/updateChatGroupSelected', patch);
        if (this.tabActive === 2) {
          this.getMembersGroup();
        }
      } else if (evType === "join_policy_updated" && data?.group_id != null) {
        const selected = this.$store.state.chat.chatGroupSelected || {};
        if (String(selected.id) === String(data.group_id)) {
          const joinPolicy = Number(data.join_policy) === 2 ? 2 : 1;
          this.$store.commit('chat/updateChatGroupSelected', {
            ...selected,
            settings: { ...(selected.settings || {}), join_policy: joinPolicy },
          });
        }
      } else if (
        evType === "join_request_resolved"
        || evType === "join_request_rejected"
        || evType === "join_request_approved"
      ) {
        if (
          String(data?.group_id) === String(this.$route.params.messenger_id)
          && this.tabActive === 3
          && data?.user_id != null
        ) {
          this.removePendingRequestFromList(data.user_id);
        }
      } else if (evType === "add_member" || evType === "join_request_created") {
        if (
          String(data?.group_id) === String(this.$route.params.messenger_id)
          && (this.tabActive === 3 || evType === "add_member")
        ) {
          this.getMembersGroup();
        }
      }
    },
    '$route.params.messenger_id'() {
      this.group_id = this.$route.params.messenger_id;
      this.params.group_id = this.$route.params.messenger_id;
      this.getMembersGroup();
    },
    '$store.state.chat.chatGroupSelected'() {
      this.isAdmin = this.$store.state.chat.chatGroupSelected.is_admin === 1;
    },
  },
  computed: {
    canAddMember() {
      return canAddChatMember(
        this.$store.state.chat.chatGroupSelected,
        this.$store.getters.user,
      );
    },
    isOfficialTeamGroupChat() {
      const g = this.$store.state.chat.chatGroupSelected || {};
      return g.type === 'GROUP' && isOfficialTeamGroup(g);
    },
    activeAdminCount() {
      const g = this.$store.state.chat.chatGroupSelected || {};
      const n = Number(g.active_admin_count);
      return Number.isFinite(n) ? n : (this.isAdmin ? 1 : 0);
    },
    showSelfAppointAdmin() {
      return this.tabActive === 2
        && !this.isLoading
        && !this.isAdmin
        && this.resultSearch.length === 0
        && this.activeAdminCount === 0;
    },
  },
  data() {
    return {
      popupActive:false,
      dropDownId : false,
      searchMember : '',
      resultSearch : [],
      TYPE_ADD_GROUP_MEMBER,
      user : this.$store.state.auth.user,
      group_id: this.$route.params.messenger_id,
      finished: false,
      params: {
        page: 1,
        per_page: 20,
        group_id: this.$route.params.messenger_id,
        keyword: '',
        only_member: 'member'
      },
      last_page: 1,
      isLoading: false,
      tabActive: 1,
      timer: null,
      page_admin: 1,
      last_page_admin: 1,
      page_request: 1,
      last_page_request: 1,
      isAdmin: this.$store.state.chat.chatGroupSelected.is_admin === 1,
      membersGroupFetchSeq: 0,
      processingBrowseRequestKey: null,
      selfAppointing: false,
    }
  },
  methods : {
    isBrowseRequestProcessing(userId, accept) {
      const key = `${userId}:${accept ? 'accept' : 'reject'}`;
      return this.processingBrowseRequestKey === key;
    },
    removePendingRequestFromList(userId) {
      const uid = String(userId);
      this.resultSearch = this.resultSearch.filter((item) => String(item.id) !== uid);
    },
    dedupePendingMembers(list) {
      const seen = new Set();
      return (list || []).filter((item) => {
        const key = String(item.id);
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
    },
    dropDownAction(elementId = false){
      this.dropDownId = this.dropDownId === elementId ? false : elementId;
    },
    hideDropDown(){
      this.dropDownId = false;
    },
    onKeyupSearch(e){
      this.params.keyword = this.searchMember;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.onRefresh();
      }, 800)
    },

    onRefresh(done) {
      this.notifications = [];
      this.params.page = 1;
      this.page_admin = 1;
      this.page_request = 1;
      this.finished = false;
      this.getMembersGroup();
      done();
    },

    onLoad(done) {
      if ((this.params.page < this.last_page) || (this.page_admin < this.last_page_admin) || (this.page_request < this.last_page_request)) {
        if(this.tabActive == 1){
          this.params.page++ 
        }else if (this.tabActive == 2){
          this.page_admin++ 
        } else {
          this.page_request++
        }
        this.getMembersGroup(true);
      } else {
        this.finished = true;
      }
      done();
    },

    getMembersGroup(loadMore = false) {
      const fetchId = ++this.membersGroupFetchSeq;
      this.isLoading = true;
      let params = {...this.params};
      if(this.tabActive == 2){
        params.page = this.page_admin;
      }
      if (this.tabActive == 3) {
        params.page = this.page_request;
        delete params.only_member;
      }
      const applyResult = (res, isPendingTab) => {
        if (fetchId !== this.membersGroupFetchSeq) {
          return;
        }
        this.isLoading = false;
        if (!res) {
          return;
        }
        const rows = Array.isArray(res.data) ? res.data : [];
        if (isPendingTab) {
          this.last_page_request = res.meta.last_page;
          const nextRows = this.dedupePendingMembers(rows);
          if (loadMore) {
            this.resultSearch = this.dedupePendingMembers(this.resultSearch.concat(nextRows));
          } else {
            this.resultSearch = nextRows.slice().reverse();
          }
          return;
        }
        this.last_page = res.meta.last_page;
        if (loadMore) {
          this.resultSearch = this.resultSearch.concat(rows);
        } else {
          this.resultSearch = rows.slice().reverse();
        }
      };
      if (this.tabActive !== 3) {
        ChatService.getMembersGroup(params).then((res) => {
          applyResult(res, false);
        }).catch(() => {
          if (fetchId === this.membersGroupFetchSeq) {
            this.isLoading = false;
          }
        });
      } else {
        ChatService.getListRequestJoinChatGroup(params).then((res) => {
          applyResult(res, true);
        }).catch(() => {
          if (fetchId === this.membersGroupFetchSeq) {
            this.isLoading = false;
          }
        });
      }
    },

    goToProfile(userId){
      window.open('/profile/' + userId, '_blank');
    },

    removeMember(member){
      this.dropDownId = false;
      this.$modal.show('dialog', {
        title: 'Xóa thành viên?',
        text: 'Bạn có chắc chắn muốn xóa thành viên này không?',
        buttons: [
          {
            title: 'Không',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Xóa',
            handler: () => {
              ChatService.removeMemberChatGroup({ user_id: member.id, group_id: this.group_id }).then(res => {
                if (res.status) {
                  this.$store.dispatch("alerts/success", `Bạn đã xóa ${member.fullname} khỏi nhóm`);
                  this.resultSearch.splice(this.resultSearch.findIndex((item) => item.id === member.id), 1);
                  // this.$store.commit('chat/updateChatGroupSelected', res.data);
                  this.$modal.hide('dialog')
                } else {
                  this.$store.dispatch("alerts/error", (res && res.message) || 'Đã có lỗi xảy ra!');
                }
              });
            }
          }
        ]
      })
    },
    callBackFunction(){},

    chosenTab(tabIndex){
      this.tabActive = tabIndex;
      this.params.only_member = tabIndex == 1 ? 'member' : 'admin';
      this.hideDropDown();
      this.getMembersGroup();
    },

    canToggleAdminRole(member) {
      if (!this.isAdmin || this.tabActive === 3 || member.id === this.user.id) {
        return false;
      }
      if (this.tabActive === 2 && this.activeAdminCount <= 1) {
        return false;
      }
      return true;
    },

    selfAppointAdmin() {
      if (this.selfAppointing) {
        return;
      }
      this.selfAppointing = true;
      ChatService.setMemberAdminChatGroup({
        is_admin: true,
        user_id: this.user.id,
        group_id: this.group_id,
      }).then((res) => {
        this.selfAppointing = false;
        if (res && res.status) {
          const selected = this.$store.state.chat.chatGroupSelected || {};
          this.$store.commit('chat/updateChatGroupSelected', {
            ...selected,
            is_admin: 1,
          });
          this.isAdmin = true;
          this.$store.dispatch('alerts/success', 'Bạn đã trở thành quản trị viên của nhóm');
          this.getMembersGroup();
        } else {
          this.$store.dispatch('alerts/error', (res && res.message) || 'Đã có lỗi xảy ra!');
        }
      }).catch(() => {
        this.selfAppointing = false;
        this.$store.dispatch('alerts/error', 'Đã có lỗi xảy ra!');
      });
    },

    setMemberAdmin(member){
      if (this.tabActive == 2 && this.activeAdminCount <= 1) {
        this.$store.dispatch(
          'alerts/error',
          'Không thể hủy quyền quản trị viên cuối. Hãy chỉ định quản trị viên khác trước.',
        );
        return;
      }
      let addRoleAdmin = this.isAdmin && this.tabActive == 1;
      const params = {
          is_admin : addRoleAdmin,
          user_id : member.id,
          group_id: this.group_id
        }
      this.dropDownId = false;
      ChatService.setMemberAdminChatGroup(params).then(res => {
        if (res && res.status) {
          let textAlert = addRoleAdmin ? `Bạn đã chỉ định ${member.fullname} làm quản trị viên` : `Bạn đã hủy ${member.fullname} làm quản trị viên`;
          this.$store.dispatch("alerts/success", textAlert);
          const idx = this.resultSearch.findIndex((item) => item.id === member.id);
          if (idx >= 0) {
            this.resultSearch.splice(idx, 1);
          }
        }else{
          this.$store.dispatch("alerts/error", (res && res.message) || 'Đã có lỗi xảy ra!');
        }
      });
    },

    textSetRole(member_id){
      let text = '';
      if(this.isAdmin && this.tabActive == 1){
        text = 'Chỉ định làm quản trị viên';
      } else if(this.isAdmin && this.tabActive == 2 && member_id !== this.user.id){
        text = 'Hủy quyền làm quản trị viên';
      }
      return text;
    },

    browseRequestJoinGroup(userId, accept) {
      const key = `${userId}:${accept ? 'accept' : 'reject'}`;
      if (this.processingBrowseRequestKey) {
        return;
      }
      const status = accept ? 'MEMBER' : 'PENDING';
      const uid = String(userId);
      const user = this.resultSearch.find((item) => String(item.id) === uid);
      if (!user) {
        this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra. Vui lòng liên hệ bộ phận IT');
        return;
      }
      const previousList = this.resultSearch.slice();
      this.processingBrowseRequestKey = key;
      this.removePendingRequestFromList(userId);
      ChatService.browseRequestJoinChatGroup({
        group_id: this.params.group_id,
        user_id: userId,
        join_state: status,
      }).then((res) => {
        if (res && res.status) {
          const textAlert = (accept ? 'Đã chấp nhận ' : 'Đã từ chối ') + user.fullname;
          this.$store.dispatch("alerts/success", textAlert);
        } else {
          this.resultSearch = previousList;
          this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra!');
        }
      }).catch(() => {
        this.resultSearch = previousList;
        this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra!');
      }).finally(() => {
        if (this.processingBrowseRequestKey === key) {
          this.processingBrowseRequestKey = null;
        }
      });
    }
  }
}
</script>

<style lang="scss">
.container-member-group{
  .list-members{
    height: calc(100vh - 200px);
    overflow-y: scroll;
  }
  .list-members::-webkit-scrollbar {
    width: 7px;
  }
  .list-members::-webkit-scrollbar-thumb {
    background: rgba(136, 136, 136, 0.4784313725);
    border-radius: 5px;
    margin: 7px;
    border-left: 2px white solid;
  }
  .list-members::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .contact-action-member{
    .remove-member{
      color: red;
    }
  }
  .self-appoint-admin{
    padding: 16px 12px 8px;
    text-align: center;
    &__text{
      margin-bottom: 12px;
      line-height: 1.5;
    }
    &__btn{
      width: 100%;
      min-height: 40px;
      border: none;
      border-radius: 8px;
      cursor: pointer;
    }
  }
}
  
</style>